import React from "react";

export const Activity = () => {

  return (
    <div className="mt-8">
      {/* <div className="flex items-center staticBanner bg-[#eac7a3] relative">
        <div className="staticBannerContent">
          <img
            src="/images/unitBanner.svg"
            alt="banner"
            className="staticBannerImg"
          />
          <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] -translate-x-1/4 max-h-full">
            <h2 className=" font-black text-primaryDark">我們的使命與價值</h2>
            <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
              為全面推動中小學數位學習精進方案，協助學校提高數位教學與學習品質及成效，高雄市政府教育局成立數位學習推動辦公室。
            </p>
          </div>
        </div>
      </div> */}
      <div className="content px-4 mx-auto pt-2">

        {/* <div className="text-xl md:text-2xl font-medium text-Headline mt-12 md:mt-16 mb-6 md:mb-8">
            活動花絮
          </div> */}

        <div className="padlet-embed" style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', boxSizing: 'border-box', overflow: 'hidden', position: 'relative', width: '100%', background: '#F4F4F4' }}>
          <p style={{ padding: '0', margin: '0' }}>
            <iframe src="https://affairs.kh.edu.tw/6856/album/album_list/81" allow="camera;microphone;geolocation" style={{ width: '100%', height: '70vh', display: 'block', padding: '0', margin: '0' }}></iframe>
          </p>
          {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', margin: '0', height: '28px' }}>
            <a href="https://padlet.com?ref=embed" style={{ display: 'block', flexGrow: '0', margin: '0', border: 'none', padding: '0', textDecoration: 'none' }} target="_blank">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src="https://padlet.net/embeds/made_with_padlet_2022.png" width="114" height="28" style={{padding:'0',margin:'0',background:'0 0',border:'none',boxShadow:'none'}} alt="創作元素為 Padlet"/>
              </div></a>
          </div> */}
        </div>
        {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-6 gap-x-4 md:gap-8 text-Headline">
                  <div className="home-resbox cursor-pointer">
                    <div className="home-img-container">
                      <img src="/images/63186c0113a01.jpg" alt="" className="home-app-image" />
                    </div>
                      <a
                        href=""
                        target="_blank"
                        rel="noreferrer noopener"
                        className="home-app-link text-base font-medium m-3"
                      >
                        數位辦公室
                      </a>
                  </div>
              </div> */}
      </div>

      <div className='p-6 lg:p-8'></div>
    </div>
  );
};
